import { Box, CircularProgress } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

import FormBuilder from "./smartForms";
import { useMetadatas } from "../hooks/metadata";
import SendMessage from "../util/message";

const INITIAL_FORM = {
  display: "form",
  components: [],
};

const StandaloneFormBuilder = () => {
  const [formState, setFormState] = useState(INITIAL_FORM);
  const [metadatasIsReady, setMetadatasIsReady] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const { data: metadatas } = useMetadatas({ params: { isPageable: false } });

  const componentsRef = useRef([]);

  useEffect(() => {
    // Notify parent that StandaloneFormBuilder is mounted and listening
    SendMessage({ status: "builder_ready" });
  }, []);

  useEffect(() => {
    if (metadatas) {
      setMetadatasIsReady(true);
    }
  }, [metadatas]);

  useEffect(() => {
    const handleMessage = (event) => {
      const { data } = event;
      if (!data) return;

      const listType = data.message || data.status || data.action;

      if (listType === "task" || listType === "signature") {
        if (data.data?.previewMode) {
          setReadOnly(true);
        }
        let receivedForm = data.data?.form || [];
        if (typeof receivedForm === "string" && receivedForm.length > 0) {
          try {
            receivedForm = JSON.parse(receivedForm);
          } catch (e) {
            console.error("Failed to parse form JSON from postMessage", e);
            receivedForm = [];
          }
        }
        setFormState({
          display: "form",
          components: receivedForm,
        });
        componentsRef.current = receivedForm;
      }

      if (listType === "save") {
        window.parent.postMessage(
          {
            message: "submit",
            data: { form: componentsRef.current },
          },
          "*",
        );
      }

      if (listType === "preview") {
        window.parent.postMessage(
          {
            message: "trigger_preview",
            data: { form: componentsRef.current },
          },
          "*",
        );
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleOnChange = (schema) => {
    if (schema && schema.lines) {
      componentsRef.current = schema.lines;
    }
  };

  if (!metadatasIsReady) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "auto",
        bgcolor: "#f5f5f5",
      }}
    >
      <FormBuilder
        metadatas={metadatas}
        form={formState}
        onChange={handleOnChange}
        canCreateMetadata={!readOnly}
        readOnly={readOnly}
        allFormFields={[]}
        businessObject={null}
      />
    </Box>
  );
};

export default StandaloneFormBuilder;
